<script>

export let params = {}

import { onMount, onDestroy } from 'svelte';

import {link} from 'svelte-spa-router'
import active from 'svelte-spa-router/active'

import { account_service       , account_service_context_key        } from './_services/account.js';
import { loggedIn                                                   } from './_services/accountsession.js';

//import AppDomoDashboard_0001		from './AppDomoDashboard/Page_0001.svelte';

//import AppPivotTable_0001			from './AppPivotTable/0001.svelte';
//import AppPivotTable_0002			from './AppPivotTable/0002.svelte';
//import AppPivotTable_0003			from './AppPivotTable/0003.svelte';
//import AppPivotTable_0004			from './AppPivotTable/0004.svelte';
import AppPivotTable_0005			from './AppPivotTable/0005.svelte';

import AppPivotTable_Drill_8iQsJsS5ujyXcjyR			from './AppPivotTable/8iQsJsS5ujyXcjyR.svelte';
import AppPivotTable_Drill_NyCZQfEFQaF2vwpk			from './AppPivotTable/NyCZQfEFQaF2vwpk.svelte';

//import MyFin_AppChart_0001			        from './AppMyFinanceStatements/Page_0001.svelte';   
import MyFin_AppChart_pLKYJaUMIdnzIEqd   from './AppMyFinanceStatements/pLKYJaUMIdnzIEqd.svelte';   
import MyFin_AppChart_0002			        from './AppMyFinanceStatements/Page_0002.svelte';   
import MyFin_AppChart_iGnn4jvwCfvOJcbu   from './AppMyFinanceStatements/iGnn4jvwCfvOJcbu.svelte';   
import MyFin_AppChart_Xa8envOyb2BZlLqo   from './AppMyFinanceStatements/Xa8envOyb2BZlLqo.svelte';   
import MyFin_AppChart_0005		           from './AppMyFinanceStatements/Page_0005.svelte';   
import MyFin_AppChart_CBwIqPCWHjIDSRXp   from './AppMyFinanceStatements/CBwIqPCWHjIDSRXp.svelte';  
import MyFin_AppPivot_Efq8Rt6TSIjukiBs   from './AppMyFinanceStatements/Efq8Rt6TSIjukiBs.svelte';  
import MyFin_AppPivot_GR4T0QBWKGiY4QbS   from './AppMyFinanceStatements/GR4T0QBWKGiY4QbS.svelte';  
import MyFin_AppChart_sUyO8KVXmwPzWVAk   from './AppMyFinanceStatements/sUyO8KVXmwPzWVAk.svelte';  
import MyFin_AppChart_FD1QqsqvCFqm4wR9   from './AppMyFinanceStatements/FD1QqsqvCFqm4wR9.svelte';  
import MyFin_AppChart_YnkEfteO9BVgdeHi   from './AppMyFinanceStatements/YnkEfteO9BVgdeHi.svelte';  
import MyFin_CrossFilter_MPvhLCGaE0uRtssv   from './AppMyFinanceStatements/MPvhLCGaE0uRtssv.svelte';  
import HousingPosts_CrossFilter_uUVs5hnqvu4Pl8Br   from './AppHousingPosts/uUVs5hnqvu4Pl8Br.svelte';  
import ObsHQ_AppAnalytics_YjcqvBSzRHVdmMti   from './AppObsHQPhoneSubNNSearch/YjcqvBSzRHVdmMti.svelte';  
import VehiclePosts_CrossFilter_Og4ZELDuMKDW1PVf   from './AppVehiclePosts/Og4ZELDuMKDW1PVf.svelte';  


import TestJWT    			from './AppTestJWT/Page.svelte';   


// -----------------------------------------------------------------
// ------  https://stackoverflow.com/questions/58110067/passing-onclick-event-into-dynamically-created-sveltecomponent
// -----------------------------------------------------------------
// ------  <svelte:component this={charts[i]} event={events[i]}/>
// -----------------------------------------------------------------


let app_list = [];
//app_list.push({ id:'', is_guest: 'Y', svelte_component: null, title:'', cover:'', description:'' });
app_list.push({ id:'YjcqvBSzRHVdmMti',     is_guest: 'Y', svelte_component: ObsHQ_AppAnalytics_YjcqvBSzRHVdmMti,       title:'ObservableHQ YjcqvBSzRHVdmMti', cover:'', description:'Analytics App PhoneSubscription Search, using ObservableHQ Framework' });
app_list.push({ id:'uUVs5hnqvu4Pl8Br',     is_guest: 'Y', svelte_component: HousingPosts_CrossFilter_uUVs5hnqvu4Pl8Br, title:'HousingPosts crossfilter uUVs5hnqvu4Pl8Br', cover:'', description:'Provides an Dynamic crossfiltering to slice and dice the Data loaded for HousingPost Features.' });
app_list.push({ id:'Og4ZELDuMKDW1PVf',     is_guest: 'Y', svelte_component: VehiclePosts_CrossFilter_Og4ZELDuMKDW1PVf, title:'VehiclePosts crossfilter Og4ZELDuMKDW1PVf', cover:'', description:'Provides an Dynamic crossfiltering to slice and dice the Data loaded for VehiclePost Features.' });

app_list.push({ id:'MPvhLCGaE0uRtssv',     is_guest: 'Y', svelte_component: MyFin_CrossFilter_MPvhLCGaE0uRtssv,   title:'MyFinance CrossFilter MPvhLCGaE0uRtssv', cover:'', description:'Provides an Dynamic crossfiltering to slice and dice the Data Loaded for Equity Ticker Positions and Features.' });
app_list.push({ id:'YnkEfteO9BVgdeHi',     is_guest: 'Y', svelte_component: MyFin_AppChart_YnkEfteO9BVgdeHi,      title:'MyFinance Chart YnkEfteO9BVgdeHi', cover:'', description:'Google Sheets Chart to provide Dividend Schedule on Revolut Tradable Instruments (Stocks)' });
app_list.push({ id:'GR4T0QBWKGiY4QbS',     is_guest: 'Y', svelte_component: MyFin_AppPivot_GR4T0QBWKGiY4QbS,      title:'MyFinance Pivot GR4T0QBWKGiY4QbS', cover:'', description:'Pivot table to check screenshot file loads for Revolut Stock Finance Statements' });
app_list.push({ id:'FD1QqsqvCFqm4wR9',     is_guest: 'Y', svelte_component: MyFin_AppChart_FD1QqsqvCFqm4wR9,      title:'MyFinance Chart FD1QqsqvCFqm4wR9', cover:'', description:'Chart to provide Performance evolution on Revolut Tradable Instruments (Stocks)' });
app_list.push({ id:'sUyO8KVXmwPzWVAk',     is_guest: 'Y', svelte_component: MyFin_AppChart_sUyO8KVXmwPzWVAk,      title:'MyFinance Chart sUyO8KVXmwPzWVAk', cover:'', description:'Google Sheets Chart to provide Performance evolution on Revolut Tradable Instruments (Stocks)' });
app_list.push({ id:'myfinance-chart-0005', is_guest: 'Y', svelte_component: MyFin_AppChart_0005,                  title:'MyFinance Chart 0005 Slider', cover:'', description:'This is a test app with a Slider Component' });
app_list.push({ id:'pivottable-0005',      is_guest: 'Y', svelte_component: AppPivotTable_0005,                   title:'AppPivotTable 0005', cover:'', description:'A quick test for Pivot Table functionalities in Svelte.' });
app_list.push({ id:'pLKYJaUMIdnzIEqd',     is_guest: 'Y', svelte_component: MyFin_AppChart_pLKYJaUMIdnzIEqd,      title:'MyFinance Chart pLKYJaUMIdnzIEqd', cover:'', description:'Contrary to popular belief, Lorem Ipsum is not simply random text.' });
app_list.push({ id:'NyCZQfEFQaF2vwpk',     is_guest: 'Y', svelte_component: AppPivotTable_Drill_NyCZQfEFQaF2vwpk, title:'PivotTable Drill NyCZQfEFQaF2vwpk', cover:'', description:'Provides an Dynamic Pivot to slice and dice the Data Loaded for FXTrading Ticker Positions and Features.' });

app_list.push({ id:'testJWT',              is_guest: 'Y', svelte_component: TestJWT,                              title:'WorkBench :: Test JWT', cover:'', description:'Contrary to popular belief, Lorem Ipsum is not simply random text.' });


app_list.push({ id:'Efq8Rt6TSIjukiBs',     is_guest: 'N', svelte_component: MyFin_AppPivot_Efq8Rt6TSIjukiBs,      title:'MyFinance Pivot Efq8Rt6TSIjukiBs', cover:'', description:'Pivot table to check file loads of Finance Statements' });
app_list.push({ id:'myfinance-chart-0002', is_guest: 'N', svelte_component: MyFin_AppChart_0002,                  title:'MyFinance Chart 0002', cover:'', description:'Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero' });
app_list.push({ id:'Xa8envOyb2BZlLqo',     is_guest: 'N', svelte_component: MyFin_AppChart_Xa8envOyb2BZlLqo,      title:'MyFinance Chart Xa8envOyb2BZlLqo', cover:'', description:'It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.' });
app_list.push({ id:'iGnn4jvwCfvOJcbu',     is_guest: 'N', svelte_component: MyFin_AppChart_iGnn4jvwCfvOJcbu,      title:'MyFinance Chart iGnn4jvwCfvOJcbu', cover:'', description:'Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero' });
app_list.push({ id:'8iQsJsS5ujyXcjyR',     is_guest: 'N', svelte_component: AppPivotTable_Drill_8iQsJsS5ujyXcjyR, title:'PivotTable Drill 8iQsJsS5ujyXcjyR', cover:'', description:'It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.' });
app_list.push({ id:'CBwIqPCWHjIDSRXp',     is_guest: 'N', svelte_component: MyFin_AppChart_CBwIqPCWHjIDSRXp,      title:'MyFinance Chart CBwIqPCWHjIDSRXp', cover:'', description:'Oanda Dashboard, providing a global overview as well as TradeableInstrument details' });



	onMount(() => {
	});


	onDestroy(() => { 
	});

</script>

<style>

  /*
        https://css-tricks.com/centering-css-complete-guide/#center-horizontally-and-vertically
        https://css-tricks.com/snippets/css/a-guide-to-flexbox/
  */

	.app_list {
		width: 1100px;
		height: auto;
		min-height: 500px;
		margin: 0 auto;
		padding: 2px;
		border: 1px solid black;
		
		display: flex; /* or inline-flex */
		/* flex-wrap: wrap; */
		flex-flow: row wrap;
		align-content: flex-start;
		align-items: flex-start;
		justify-content: flex-start; /* flex-start | space-around | space-evenly*/
	}

	
	.app_list_subtitle {
		display: flex; /* or inline-flex */
		flex-flow: row wrap;
	   width: 100%;
		padding: 2px;
		border: 1px solid black;
	}

	app_item {
		display: flex; /* or inline-flex */
		flex-flow: row wrap;
		list-style: none;
	   width: 250px;
	   height: 180px;
		border: 1px solid black;
		padding: 2px;
		margin: 8px;
		background-color: #fcfcff;
		filter: drop-shadow(0 2px 0.15rem rgba(0, 102, 102, 0.33) );
	}
	
	app_item_title	{
		font-size: larger;
	   width: inherit;
		display: inline; 
		align-self: flex-start;
		position: absolute;
	}
	
	app_item_description {
		font-size: smaller;
	   width: inherit;
	   height: 70px;
		display: inline; 
		align-self: flex-end;
		position: absolute;
	}
	
</style>


<h1>This is AppListPage</h1>

<div class="app_list">

{#if params.app_id === undefined}
<p>please select an app from the list below</p>
	<div class="app_list_subtitle"> Guest Apps </div>
	{#each app_list as { id, is_guest, title, description }, i}
		{#if is_guest === 'Y'}
			<app_item id="{id}">
			<app_item_cover></app_item_cover>
			<app_item_title><a href="/applist/{id}/" use:link >{title}</a></app_item_title>
			<app_item_description>{description}</app_item_description>
			</app_item>

		{:else }
		&nbsp;

		{/if}

	{/each}

	{#if $loggedIn}

	<div class="app_list_subtitle"> Member Apps </div>
	{#each app_list as { id, is_guest, title, description }, i}
		{#if is_guest !== 'Y'}
			<app_item id="{id}">
			<app_item_cover></app_item_cover>
			<app_item_title><a href="/applist/{id}/" use:link >{title}</a></app_item_title>
			<app_item_description>{description}</app_item_description>
			</app_item>
		{/if}
	{/each}
	
	{:else }
	&nbsp;
	
	{/if}


{:else }


<!-- -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= -->

	{#each app_list as { id, is_guest, svelte_component }, i}
		{#if params.app_id === id}
		<svelte:component this={ svelte_component } />
		{/if}
	{/each}


<!-- -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= -->

{/if}

</div>


<br/>
<br/>
<br/>
